module.exports = __webpack_public_path__ + "static/media/Alba soffa 2,5-sits öppet avslut tyg Aragon light grey detalj 2024 3 fyrkant.e657d50d.jpg";